// @ts-ignore TODO
{ load: loadGist } from ./lib/legacy/gist
ReadFile from ./lib/read-file.civet

clipboardCopy from ./lib/clipboard-copy.civet

// @ts-ignore TODO: jadelet types
Button from ./templates/button.jadelet
// @ts-ignore TODO: jadelet types
LoadURLTemplate from ./templates/load-url.jadelet
// @ts-ignore TODO: jadelet types
SaveFormTemplate from ./templates/save-form.jadelet
// @ts-ignore TODO: jadelet types
PublishTemplate from ./templates/publish.jadelet

Spritesheet from ./lib/spritesheet.civet

{ bufferStartsWith } from ./lib/util.civet
{ soundBankFormat } from @danielx/lib
{ PUBLISH_URL } from ./const.civet

{ urlSafeSHA256 } from @danielx/lib
type { SynthEngine } from @danielx/lib

MidiSong, { type StateData } from ./lib/midi/song.civet

{
  Drop
  Login
  Modal
  Observable
  Progress
} from @danielx/dui

type { ObservableValue } from @danielx/observable

publishView := Progress
  message: "Saving..."

loadingView := Progress
  message: "Loading..."

cancelled := {message: "cancelled"}

ACCOUNT_BASE_DIR := "/data/danielx.net/composer/songs/"

export Persistence := <T extends Constructor>(S: T) ->
  abstract class Persistence extends S
    abstract loadSpritesheetFromBlob(blob: Blob): void
    abstract notifyWarning(message: unknown): void
    abstract pushState(data: unknown): void
    abstract setSf2Synth(data: ArrayBuffer): void
    abstract showAccountSongPicker(data: ???): void
    abstract song: MidiSong
    abstract spritesheetBlob: Blob
    abstract synth(): SynthEngine
    abstract trigger(event: string, ...parameters: any[]): void

    openFile: => void
    removeUnloadHandler: => void

    constructor(...args: any[])
      super(...args)

      fileInput := ReadFile
        accept: ".dxc,.mid,audio/mid,.midi,audio/midi,.synthesia,.png,image/png,.sf2,.sf3,.dls"
        change: (file) =>
          try
            await @fromBlob(file)
          catch e
            console.error e
          finally
            Modal.hide()

      fileInput.style.display = "none"
      document.body.appendChild fileInput

      Drop document, (e: DragEvent) =>
        return if e.defaultPrevented
        files := e.dataTransfer?.files
        if files?.length
          e.preventDefault()
          @fromBlob files[0]

      document.addEventListener "paste", (e: ClipboardEvent) =>
        return if e.defaultPrevented
        { clipboardData } := e
        return unless clipboardData
        file .= clipboardData.files[0]
        unless file
          for item of clipboardData.items
            if f := item.getAsFile()
              file = f
              break
        if file
          e.preventDefault()
          @fromBlob file

      // Open from account if logged in, otherwise file input from local system
      @openFile = =>
        fileInput.click()

      @removeUnloadHandler = =>
        window.removeEventListener "beforeunload", unloadHandler

      // NOTE: Track `prompted` so in an iframe it won't trigger twice
      prompted .= false
      unloadHandler := (e: BeforeUnloadEvent) =>
        return if prompted
        prompted = true
        setTimeout ->
          prompted = false

        if @unsaved()
          e.returnValue = "Your changes haven't yet been saved. If you leave now you will lose your work."

        return e.returnValue
      window.addEventListener "beforeunload", unloadHandler

      // This handles loading from the shareable link url hash.
      setTimeout =>
        if hash := location.hash
          @loadFromSlug hash.substr(1)
      , 0

    unsaved = Observable false

    // Display a non-cancellable loading modal
    // Used when waiting for external API calls, remove with Modal.hide() in the
    // .finally of a promise or when another modal is displayed.
    displayLoadingModal()
      Modal.show loadingView.element,
        cancellable: false

    account = Observable null |> as ObservableValue<any>

    accountInfo = =>
      acct := @account()

      if acct
        `Account id: ${acct.id}`
      else
        "Anonymous"

    accountButtonClick = =>
      account := @account()
      if account
        account.logout()
        @account null
      else
        new Promise (resolve, reject) ->
          Login {
            resolve
            reject
            cognito: window.cognitoConfig
          }
        .then @account
        .catch (e) ->
          console.warn e if e

    accountButtonDescription = =>
      if @account()
        "Logout"
      else
        "Login"

    saveActionTitle = =>
      if @account()
        "Save to account"
      else
        "Save to disk"

    saveToAccountButton = =>
      account := @account()

      if account
        Button
          text: "Save to account"
          click: @saveToAccount

    loadFromAccountButton = =>
      account := @account()

      if account
        Button
          text: "Load from account"
          click: @loadFromAccount

    // Save to local system
    saveFile = =>
      song := @song
      Modal.form SaveFormTemplate
        saveActionTitle: "Save to disk"
        title: song.title()
        description: song.description()
        cancel: (e: Event) ->
          e.preventDefault()
          Modal.hide()
      // @ts-expect-error `SongData` type
      .then (data?: {title: string, description: string}) =>
        throw cancelled unless data

        {title, description} := data
        song.title title
        song.description description

        blob := song.toBlob()
        ext := "midi"

        blob.download(`${title}.${ext}`)
      .then =>
        @unsaved false
      .catch (e: ???) ->
        return if e is cancelled
        console.error e
      .finally ->
        Modal.hide()

    // Save to account
    saveToAccount = =>
      song := @song
      Modal.form SaveFormTemplate
        saveActionTitle: "Save to account"
        title: song.title()
        description: song.description()
        cancel: (e: Event) ->
          e.preventDefault()
          Modal.hide()
      // TODO: prompt for account login if no account?
      .then (data?: {title: string, description: string}) =>
        throw cancelled unless data

        // Update song metadata
        {title, description} := data
        song.title title
        song.description description

        account := @account()
        blob := song.toBlob()

        ext := "midi"

        if account
          song.authorId account.id
          // TODO: Author name

          Modal.show publishView.element,
            cancellable: false
          // TODO: add to public feed/listing if desired
          @publishAssets()
          .then ->
            account.fs.write(`${ACCOUNT_BASE_DIR}${title}.${ext}`, blob)
      //@ts-expect-error
      .then =>
        @unsaved false
      .catch (e: ???) ->
        return if e is cancelled
        console.error e
      .finally ->
        Modal.hide()

    openActionTitle = =>
      if @account()
        "Load from account"
      else
        "Load from disk"

    loadFromAccount = =>
      @displayLoadingModal()

      account := @account()

      if !account
        ; // TODO prompt for login

      account.fs.list(ACCOUNT_BASE_DIR).then (entryData: ???) =>
        @showAccountSongPicker entryData

    loadFromAccountPath = (path: string) =>
      @displayLoadingModal()

      @account().fs.read path
      .then @fromBlob
      .catch console.error
      .finally ->
        Modal.hide()

    loadFromSlug = (slug: string) =>
      if slug.match /^url-/
        @loadURL decodeURIComponent slug.substr(4)
      else if slug.match /^api-/
        @loadAPIData(slug.substr(4))
      else if slug
        @loadGist slug

    loadURL = (url: Parameters<typeof fetch>[0]) =>
      fetch(url)
      .then (result) ->
        result.blob()
      .then @fromBlob

    loadFromURLString = =>
      Modal.form LoadURLTemplate
        url: "https://danielx.net/composer/#api-4IuXACKoqtSke9jTAThC5I_eWc4me53ze-1cri-L8kE"
        cancel: (e: Event) ->
          e.preventDefault()
          Modal.hide()
      //@ts-expect-error
      .then (data?: {url?: string}) =>
        return unless {url} := data
        return unless url
        if url.indexOf("#")
          [_, slug] := url.split("#")
          @loadFromSlug(slug)
        else
          @loadURL(url)

    loadDemo = =>
      await @confirmUnsaved()

      Modal.hide()
      @fromJSON(require("./data/demo"))

    getState = =>
      @song.getState()

    restoreState = (data: StateData) =>
      @song.restoreState(data)

    // Returns a promise that resolves if there are no unsaved changes or the
    // the user confirms they are willing to lose unsaved changes.
    confirmUnsaved = =>
      if @unsaved()
        confirmed := await Modal.confirm "If you continue your changes will be lost!", "Unsaved changes!"
        throw undefined unless confirmed

    loadFile = (blob: Blob) =>
      @fromBlob blob

    // add auto-detection with first few bytes of file by using
    // `bufferStartsWith`
    fromBlob = (blob: Blob) =>
      // Files will have name, but blobs won't
      { type, name } := blob as Blob & {name?: string}

      arrayBuffer := await blob.arrayBuffer()

      b := new Uint8Array arrayBuffer

      if bufferStartsWith(b, "MThd") or type.match /^audio\/(x-)?midi?/
        @song.init b
        // Hash the ORIGINAL bytes and apply any registered .synthesia
        // metadata before this lands in the undo stack
        @practiceMidiImported? b
        @pushState @getState()
        @trigger "reset"
      else if name?.match(/\.synthesia$/i) or bufferStartsWith(b, "<?xml") and
          new TextDecoder().decode(b.subarray(0, 512)).includes("SynthesiaMetadata")
        @importSynthesiaMetadata? new TextDecoder().decode arrayBuffer
      else if type.match(/^application\/(.*\+)?json$/) or name?.match(/\.dxc/)
        blob.json()
        .then (json) =>
          @fromJSON(json)
      // SF2, SF3 and DLS: the SpessaSynth engine reads all three; SF2Synth refuses the
      // last two with an error that says so.
      else if soundBankFormat(arrayBuffer) or name?.match /\.(sf2|sf3|dls)$/i
        @setSf2Synth(arrayBuffer)
      else if bufferStartsWith(b, "\x89PNG") or type.match /^image\/png$/
        Spritesheet.convert blob
        .then @loadSpritesheetFromBlob
        .catch (e: ???) ->
          if e !== "Cancelled"
            throw e
      else
        // TODO: Toast notify?
        console.warn "Unknow file type", blob, b

    fromJSON = (data: ???): void =>
      @song.fromJSON(data)

      @pushState @getState()
      @trigger 'reset'

    ensureCDNResourceNotFound(sha: string)
      res := await fetch `https://data.danielx.net/composer/${sha}`,
        method: 'HEAD'

      if res.ok
        throw "found"

      // returns 403 when file doesn't exist though maybe the service should be updated to return 404
      if res.status is 403 or res.status is 404
        return
      else
        throw res

    publishToS3Incoming = (blob: Blob) =>
      // check for existing sha
      sha := await urlSafeSHA256 blob

      await @ensureCDNResourceNotFound(sha)

      res := await fetch `https://whimsy-fs-incoming.s3.amazonaws.com/_apps/composer/incoming/${sha}`,
        method: "PUT"
        body: blob

      if res.ok
        return sha
      else
        throw res

    publishToCDN = (blob: Blob) =>
      let sha
      try
        // check for existing sha
        sha = await urlSafeSHA256 blob

        await @ensureCDNResourceNotFound(sha)

        type := blob.type or "application/octet-stream"

        // The real content type rides in the query string. The body goes as
        // octet-stream so the HTTP API hands it to the function base64; as
        // text/plain it arrives as a UTF-8 string with every invalid byte
        // replaced, which corrupts MIDI, PNG and soundfont uploads.
        stored := fetch `${PUBLISH_URL}?content-type=${type}`,
          method: 'POST'
          body: blob
          headers:
            'Content-Type': 'application/octet-stream'
        |> await
        |> .json()
        |> await

        if stored !== sha
          throw new Error `Published bytes don't match: sent ${sha}, stored ${stored}`

        stored

      catch e
        if e is 'found'
          return sha
        else
          throw e

    publishAsset = (blob: Blob) =>
      {size} := blob

      // API Gateway max payload size is 10MB
      if size < 9.5 * 1024 * 1024
        @publishToCDN blob
      else if size < 20 * 1024 * 1024
        @publishToS3Incoming blob
      else
        throw new Error "Can't publish assets larger than 20MB"

    publishSpritesheet = =>
      blob := @spritesheetBlob

      if blob
        return @publishAsset(blob)
      else
        return

    // Publish spritesheet, synth, any other assets to global CAS CDN
    publishAssets = =>
      try
        await.all [
          @publishSpritesheet()
          @publishAsset(@synth().toBlob())
        ]
      catch e
        if e !== "found"
          @notifyWarning e

        // Continue with publishing midi
        return

    publish = =>
      Modal.show publishView.element,
        cancellable: false

      try
        await @publishAssets()
        sha := await @publishToCDN @song.toBlob()

        url := `https://danielx.net/composer/#api-${sha}`

        try
          history.replaceState({}, "", url)
        catch e
          console.warn e

        Modal.show PublishTemplate(
          value: url
          status: Observable ""
          copy: ->
            clipboardCopy(url)
            @status "Copied!"
          done: ->
            Modal.hide()
        ),
          cancellable: false

      catch e
        console.warn e
        Modal.hide()

    loadAPIData = (id: string) =>
      fetch `https://data.danielx.net/composer/${id}`,
        method: 'GET'
      .then .blob()
      .then @fromBlob
      .then ->
        location.hash = "api-" + id

    // Load legacy format songs from when we could save them as anonymous Github
    // gists.
    loadGist = (id: string) =>
      try
        data := await loadGist(id)

        await @confirmUnsaved()
        await @fromJSON(data)

        location.hash = id
      catch
        Modal.alert `Couldn't load gist with id: ${id}`

    loadGistPrompt = =>
      if id := prompt "Gist id", location.hash.substr(1) || "0b4c4656a6eb1d246829"
        @loadGist(id)

  return Persistence

export default Persistence
